// extracted by mini-css-extract-plugin
export default {"approvalStateTag":"index-module--approvalStateTag--Ofu7w"};